import CryptoJS from "crypto-js";

const SECRET = process.env.REACT_APP_SECRET_KEY;
const IV_TEXT = process.env.REACT_APP_IV;

export function encryptBody(body, { includeIv = false } = {}) {
    
    if (!SECRET || !IV_TEXT) {
        throw new Error("Missing REACT_APP_SECRET_KEY or REACT_APP_IV");
    }

    const keyWordArray = CryptoJS.SHA256(SECRET);
    const ivWordArray = CryptoJS.MD5(IV_TEXT);

    const plaintext = JSON.stringify(body ?? {});

    const encrypted = CryptoJS.AES.encrypt(plaintext, keyWordArray, {
        iv: ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    const encryptedB64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    const output = includeIv
        ? { data: encryptedB64, iv: CryptoJS.enc.Base64.stringify(ivWordArray) }
        : { data: encryptedB64 };

    return output;
}

